$(function () {
    if (window.__chatWithSalesPopupTradeHasFired) {
      return;
    }

    window.Branch = window.Branch || {};
    window.Branch.chatWithSalesPopupTrade = window.Branch.chatWithSalesPopupTrade || {};
    window.Branch.chatWithSalesPopupTrade.sliders = window.Branch.chatWithSalesPopupTrade.sliders || {};
    window.__chatWithSalesPopupTradeHasFired = true;

    function handleChatWithSalesOnClick(evt){
        let parent = evt.target.closest('.shopify-section')
        let parentId = parent.getAttribute('id');
        if(evt.target.closest('.chat-with-sales-button-trade') && evt.target.closest('.chat-with-sales-button-trade').getAttribute('data-type') != 'regular'){
            parentId = null;
        }

        let selector = `${parentId ? `#${parentId}` : ''} .chat-with-sales-popup-trade${parentId ? '' : ':not([data-type="regular"])'}:last`;
        console.log('parentId', parentId)
        console.log('selector!!!', selector)
        Simplistic.openModal($(`${selector}`), 'regular');
        return false;
    }

    function initChatWithSalesPopupTrade(chatWithSalesPopupTradeSection, parent){
        let parentId = chatWithSalesPopupTradeSection.closest('.shopify-section') ? chatWithSalesPopupTradeSection.closest('.shopify-section').getAttribute('id') : null;
        let selector = `${parentId ? `#${parentId}` : ''} .chat-with-sales-button-trade${parentId ? '' : ':not([data-type="regular"])'}`;

        console.log('selector', selector);
        console.log('parentId', parentId);

        $(document).off('click', selector);
        $(`.tingle-modal-box__content .chat-with-sales-popup-trade`).not(':last').remove();
        $(document).on('click', selector, handleChatWithSalesOnClick);

        $(`${parentId ? `#${parentId}` : ''} .chat-with-sales-popup-trade${parentId ? '' : ':not([data-type="regular"])'} form`).submit(function(e){
            e.preventDefault();
            e.stopImmediatePropagation();
            var form = $(this);
            var error = false;
            
            form.parent().find('.error-msg').hide().text('');
            form.find('.error').removeClass('error');
            form.find('[aria-invalid]').removeAttr('aria-invalid');

            form.find('.required').each(function(){
            if($(this).val()=="") {
                error = true;
                $(this).addClass('error').attr('aria-invalid', 'true');
            }
            });
            
            if(error){
                form.parent().find('.error-msg').show().text('Please complete all the required fields.');
                form.find('[aria-invalid="true"]').first().trigger('focus');
            }else{
            if(!Simplistic.validateEmail(form.find('input[name="contact[email]"]').val())) {
                error = true;
                form.find('input[name="contact[email]"]').addClass('error').attr('aria-invalid', 'true');
                form.parent().find('.error-msg').show().text('Please provide a valid email address.');
                form.find('[aria-invalid="true"]').first().trigger('focus');
            }
            }

            // Prepare form data
            var firstName = form.find('input[name="contact[firstname]"]').val() || '';
            var lastName = form.find('input[name="contact[lastname]"]').val() || '';
            var productTitle = form.find('input[name="contact[product]"]').val() || '';
            var requestedFileType = form.find('input[name="contact[requested_file_type]"]').val() || '';
            
            // Get the requested file info from the popup data
            var $popup = form.closest('.chat-with-sales-popup-trade');
            var requestedFileUrl = $popup.data('requested-file-url');

            function getHubSpotCookie() {
            const cookies = document.cookie.split(';');
            const hubspotCookie = cookies.find(cookie => cookie.trim().startsWith('hubspotutk='));
            return hubspotCookie ? hubspotCookie.trim().substring('hubspotutk='.length) : '';
            }

            if(!error) {
            var processAjax = function(arr, callback){
                var pending = arr.length;
                $.each(arr, function(){
                this.always(function(){
                    pending--;
                    if(pending==0) {
                    callback();
                    }
                });
                });
            };
            var ajaxHubspot = $.ajax({
                'url': 'https://api.hsforms.com/submissions/v3/integration/submit/5361087/b7942769-0fbc-45f1-b447-fdfa1bedd175',
                'type': 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                fields: [
                        {name: 'firstname', value: firstName || ''},
                        {name: 'lastname', value: lastName || ''},
                        {name: 'company', value: form.find('input[name="contact[company]"]').val() || ''},
                        {name: 'email', value: form.find('input[name="contact[email]"]').val() || ''},
                        {name: 'phone', value: form.find('input[name="contact[phone]"]').val() || ''},
                        {name: 'i_m_a_an', value: form.find('select[name="contact[i_m_a_an]"]').val() || ''},
                        {name: 'i_m_looking_to', value: form.find('select[name="contact[i_m_looking_to]"]').val() || ''},
                        {name: 'estimated_furniture_budget', value: form.find('select[name="contact[estimated_furniture_budget]"]').val() || ''},
                        {name: 'requested_product', value: productTitle || ''},
                        {name: 'requested_file_type', value: requestedFileType || ''}
                    ],
                context: {
                    hutk: getHubSpotCookie(),
                    pageUri: window.location.href,
                    pageName: document.title
                }
                })
            });
            processAjax([ajaxHubspot], function(){
                // Hide form and show success message
                form.parent().hide();
                form.parent().parent().find('.success-msg').show().find('h2').trigger('focus');
                
                // Set session storage to remember form submission
                sessionStorage.setItem('branch_trade_form_submitted', 'true');
                sessionStorage.setItem('branch_trade_form_timestamp', Date.now());
                
                // Animate progress bar
                var progressFill = $('.progress-fill');
                var progressText = $('.progress-text');
                
                // Progress animation
                setTimeout(function() {
                progressFill.css('width', '30%');
                progressText.text('Processing your request...');
                }, 500);
                
                setTimeout(function() {
                progressFill.css('width', '70%');
                progressText.text('Preparing download...');
                }, 1500);
                
                setTimeout(function() {
                progressFill.css('width', '100%');
                progressText.text('Download ready!');
                
                // Start the download if we have a file URL
                if (requestedFileUrl) {
                    if(requestedFileUrl.includes('pdf')){
                        var tempLink = document.createElement('a');
                        tempLink.href = requestedFileUrl;
                        const filename = requestedFileUrl.split('/').pop().split('?')[0];
                        tempLink.setAttribute('download', filename);
                        tempLink.setAttribute('target', '_blank');
                        document.body.appendChild(tempLink);
                        tempLink.click();
                        document.body.removeChild(tempLink);
                    } else {
                        var tempLink = document.createElement('a');
                        tempLink.href = requestedFileUrl;
                        tempLink.download = '';
                        document.body.appendChild(tempLink);
                        tempLink.click();
                        document.body.removeChild(tempLink);
                    }

                    // Track the download
                    if (typeof gtag !== 'undefined') {
                    gtag('event', 'file_download', {
                        'file_type': requestedFileType,
                        'product': productTitle,
                        'event_category': 'Trade Resources Paywall'
                    });
                    }
                }
                
                // Close modal and reload page after download starts
                setTimeout(function() {
                    modal.close();
                    // Reload to show all files as unlocked
                    if(document.querySelector('body.template-page-resources')) {
                        window.location.reload();
                    }
                }, 2000);
                }, 2500);
            });
            }
        });
    }

function actionsOnVisible(chatWithSalesPopupTradeSection, parent){
        chatWithSalesPopupTradeSection.setAttribute('data-interacted', true);
        initChatWithSalesPopupTrade(chatWithSalesPopupTradeSection, parent);
    }    

function initChatWithSalesPopupTradeCallback(chatWithSalesPopupTradeSection, parent, type){
        let chatWithSalesPopupTradeSectionParent = chatWithSalesPopupTradeSection.closest('.shopify-section')
        let fromLoad = chatWithSalesPopupTradeSection.closest('.homepage-content-container') && chatWithSalesPopupTradeSection.closest('.homepage-content-container').getAttribute('data-origin') == 'load';

        if(type == 'from-copy' && fromLoad == false){
            actionsOnVisible(chatWithSalesPopupTradeSection, parent);
        } else if(!chatWithSalesPopupTradeSection.closest('.homepage-content-container')) {
            actionsOnVisible(chatWithSalesPopupTradeSection, parent);
        } else if(chatWithSalesPopupTradeSectionParent) {


            const containerRect = {top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight};
            const scrollContainer = chatWithSalesPopupTradeSection.closest('.homepage-content-container') ? chatWithSalesPopupTradeSection.closest('.homepage-content-container') : document.querySelector('#page');
            const scrollHandler = function () {
            const containerRect = scrollContainer.getBoundingClientRect();
            const targetRect = chatWithSalesPopupTradeSectionParent.getBoundingClientRect();

            const isVisible =
                targetRect.bottom > containerRect.top &&
                targetRect.top < containerRect.bottom;

            if (
                isVisible &&
                chatWithSalesPopupTradeSection.getAttribute("data-interacted") !== "true"
            ) {
                
                actionsOnVisible(chatWithSalesPopupTradeSection, parent);
                chatWithSalesPopupTradeSection.setAttribute("data-interacted", "true");
                scrollContainer.removeEventListener("scroll", scrollHandler);
            }
        };

        scrollContainer.addEventListener("scroll", scrollHandler);
        } else {
            actionsOnVisible(chatWithSalesPopupTradeSection, parent);
        }
    }

    window.Branch.chatWithSalesPopupTrade.chatWithSalesPopupTradeInitOnLoad = function(type){
        let chatWithSalesPopupTradeSections = document.querySelectorAll('.chat-with-sales-popup-trade:not([data-initialized="true"])');
        
        chatWithSalesPopupTradeSections.forEach((chatWithSalesPopupTradeSection) => {
            let parent = chatWithSalesPopupTradeSection.closest('.shopify-section');
            chatWithSalesPopupTradeSection.setAttribute('data-initialized', true);
            if(type == 'from-copy'){
                 initChatWithSalesPopupTradeCallback(chatWithSalesPopupTradeSection, parent, type)
            } else {
                 window.Branch.functions.fireOnUserInteraction(initChatWithSalesPopupTradeCallback, '.homepage-content-container', chatWithSalesPopupTradeSection, chatWithSalesPopupTradeSection, parent);
             }
        })  
    }

    if (document.readyState === "complete") {
        window.Branch.chatWithSalesPopupTrade.chatWithSalesPopupTradeInitOnLoad('regular'); 
    } else {
        window.addEventListener("load", () => window.Branch.chatWithSalesPopupTrade.chatWithSalesPopupTradeInitOnLoad('regular'));
    }
  });
